import { api } from '@/plugins/api'

export const getFedIdUrlV2 = async () => {
  try {
    const { data } = await api.get('/api/login')
    return data.result
  } catch (error) {
    console.error('Error en getFedIdUrlV2:', error)
    throw error
  }
}

export const getProfile = async (config = {}) => {
  try {
    const { data } = await api.get('/api/user/profile', config)
    return data.result
  } catch (error) {
    console.error('Error en getFedIdUrlV2:', error)
    throw error
  }
}
